import { AcceleratorBatch } from '../lib/batches';
import type {
  DemoDay,
  DemoDayCompany,
  DemoDayInvestor,
  DemoDayViewer,
} from '../lib/demo-day';
import { z } from 'zod';

export const listDemoDayCompaniesQuerySchema = z.object({
  batch: z.nativeEnum(AcceleratorBatch),
});

export type ListDemoDayCompaniesQuery = z.infer<
  typeof listDemoDayCompaniesQuerySchema
>;

export type ListDemoDayCompaniesResponse = {
  companies: DemoDayCompany[];
};

export const listDemoDayViewersQuerySchema = z.object({
  batch: z.nativeEnum(AcceleratorBatch),
});

export type ListDemoDayViewersQuery = z.infer<
  typeof listDemoDayViewersQuerySchema
>;

export type ListDemoDayViewersResponse = {
  viewers: DemoDayViewer[];
  liveViewerCount: number;
};

export const demoDayLoginSchema = z.object({
  email: z.string().email({ message: 'Invalid email address' }).trim(),
  password: z.string().min(1, { message: 'Password is required' }).trim(),
});

export type DemoDayLoginBody = z.infer<typeof demoDayLoginSchema>;

export type DemoDayLoginResponse = {
  success: boolean;
  name: string | null;
  profileComplete: boolean;
};

export const demoDayProfileSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }).trim(),
  companyName: z
    .string()
    .min(1, { message: 'Company or fund name is required' })
    .trim(),
});

export type DemoDayProfileBody = z.infer<typeof demoDayProfileSchema>;

export const demoDaySessionPayloadSchema = z.object({
  _internal_demo_day_user_id: z.number(),
  _name: z.string().optional(),
  _company_name: z.string().trim().optional(),
  _profile_complete: z.boolean(),
});

export type DemoDaySessionPayload = z.infer<typeof demoDaySessionPayloadSchema>;

export type RetrieveDemoDayResponse = {
  demoDay: DemoDay;
};

export const fetchSchedulingLinkQuerySchema = z.object({
  companyId: z.coerce.number(),
  demoDayId: z.coerce.number(),
});

export type FetchSchedulingLinkQuery = z.infer<
  typeof fetchSchedulingLinkQuerySchema
>;

export type FetchSchedulingLinkResponse = {
  schedulingLink: string;
};

export const listDemoDayInvestorsQuerySchema = z.object({
  batch: z.nativeEnum(AcceleratorBatch),
});

export type ListDemoDayInvestorsQuery = z.infer<
  typeof listDemoDayInvestorsQuerySchema
>;

export type ListDemoDayInvestorsResponse = {
  investors: DemoDayInvestor[];
};
